<template>
  <div class="flex flex-row justify-between">
    <span class="heading-xxs text-text-primary">{{ labelText }}</span>
    <span class="heading-xxs text-text-primary">
      <slot />
    </span>
  </div>
</template>

<script lang="ts" setup>
defineProps<{ labelText: string }>();
</script>

<style lang="scss" scoped></style>
